'use strict';

angular.module('mobile-apps')
	.directive('entryStatus',['EntryStatus', function(EntryStatus) {
		return {
			restrict: 'E',
			scope:
			{
				status: '@'
			},
			link: function(scope, element, attrs) {

				// Define how the different statuses should be displayed
				var statusInformation = EntryStatus.statusInformation;

				function updateData() {
					var contentString = '';
					var classes = '';
					var styles = '';
					var title = 'No status';

					if (scope.status !== '') {
						if (statusInformation.hasOwnProperty(scope.status)) {
							var statusData = statusInformation[scope.status];
							if (statusData.hasOwnProperty('icon')) {
								contentString = '<i class="' + statusData.icon + '" aria-hidden="true"></i>';
								styles += 'color: ' + statusData.color;
							} else {
								classes += ' status-circle';
								styles += 'background-color: ' + statusData.color;
							}
							title = statusData.name;
						} else {
							// Should never happen but if there is an unknown status
							// we display it also as an empty circle
							title = 'unknown';
							classes += ' status-circle status-circle-empty';
						}
					} else {
						// If there is no status set we display an empty circle
						classes += ' status-circle status-circle-empty';
					}

					element.html('<div title="' + title + '" class="status-display ' + classes + '" style="' + styles + '">' + contentString + '</div>');
				}

				scope.$watch('status', function(status) {
					updateData();
				});

			}
		};
	}]);
